import React from "react";
import { DropDown } from "src/pages/experiences/storyboardSettings/components/siteSettings/dropdown";
import { REPORT_TYPES } from "../constants";
import { ReportType } from "src/types/experiences/leadsAndReports";
import styles from "./common.module.scss";

interface ReportTypeDropdownProps {
  value: ReportType;
  // eslint-disable-next-line no-unused-vars
  onChange: (value: ReportType) => void;
}

export const ReportTypeDropdown: React.FC<ReportTypeDropdownProps> = ({ value, onChange }) => {
  const options = Object.values(REPORT_TYPES).map((rt) => ({ key: rt.value, label: rt.label }));

  return (
    <DropDown
      selected={{ key: value, label: REPORT_TYPES[value].label }}
      options={options}
      onChange={(key) => onChange(key as ReportType)}
      className={styles.reportTypeDropdown}
    />
  );
};
